import { RssUpdatePeriod } from '@/entities/content/api/types';
import type { SelectOption } from '@/shared';

export const animationOptions: SelectOption[] = [
  {
    value: '',
    label: 'No effect',
  },
  {
    value: 'fade-in',
    label: 'Fade In',
  },
  {
    value: 'zoom-in',
    label: 'Zoom In',
  },
];

export const firstUpdateOptions: SelectOption[] = [...Array(24).keys()].map(
  (_, idx) => ({
    value: `${idx}:00`.padStart(5, '0'),
    label: `${idx}:00`.padStart(5, '0'),
  })
);

export const periodOptions: SelectOption[] = [
  {
    value: RssUpdatePeriod.Every24Hours,
    label: 'Every 24 hours',
  },
  {
    value: RssUpdatePeriod.Every48Hours,
    label: 'Every 48 hours',
  },
  {
    value: RssUpdatePeriod.Every7Days,
    label: 'Every 7 days',
  },
];
